import React, { useContext, useLayoutEffect, useRef } from 'react';
import { WebShellContext } from './WebShellContext';

export default function useWebHeader(
  headerNode: React.ReactNode | null,
  active = true,
) {
  const shell = useContext(WebShellContext);
  const ownerIdRef = useRef<symbol>(Symbol('web-header'));

  useLayoutEffect(() => {
    if (!shell) return;

    if (active && headerNode) {
      shell.setHeader(ownerIdRef.current, headerNode);
      return;
    }

    shell.clearHeader(ownerIdRef.current);
  }, [active, headerNode, shell]);

  useLayoutEffect(() => {
    if (!shell) return;

    const ownerId = ownerIdRef.current;
    return () => {
      shell.clearHeader(ownerId);
    };
  }, [shell]);
}
